import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64cf9e1f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf9e1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64cf9e1f')) {
      api.createRecord('64cf9e1f', component.options)
    } else {
      api.reload('64cf9e1f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64cf9e1f&scoped=true", function () {
      api.rerender('64cf9e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Gd/SupplierList/index.vue"
export default component.exports